// NOTE Do not import like that it seems that then they are constants and the state is shared
// import { state, getters, actions, mutations } from '@shared/store/abstract-form.store';

import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { bpcApi } from '@core/services/bpc-api.service';
import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
import { Terminal } from '@payment-terminals/interfaces/terminal';

const bpcRouterHelper = new BPCApiRouteHelper();

const state = {
  terminals: [],
  loading: false,
};

const getters = {
  terminals: (state): Terminal[] => {
    return state.terminals || [];
  },
};
const actions = {
  getTerminals({ commit }): void {
    commit('startLoading');
    bpcApi
      .get(bpcRouterHelper.getEntityPath('terminals'), {
        params: { status: 'active' },
      })
      .subscribe(
        (res: BPCGenericApiResponse) => {
          commit('storeTerminals', res.data);
          commit('stopLoading');
        },
        error => {
          console.log(error);
          commit('stopLoading');
        },
      );
  },
};
const mutations = {
  storeTerminals(state, data: Terminal[]) {
    state.terminals = data;
  },
  clearTerminals(state) {
    state.terminals = [];
  },
  stopLoading(state) {
    state.loading = false;
  },
  startLoading(state) {
    state.loading = true;
  },
};

export const PaymentTerminalsStoreModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
